import React from 'react';
import {inject} from 'mobx-react'
import {observe} from 'mobx';
import classNames from 'classnames';
@inject('searchFieldEventEmitter')
export default class SearchField extends React.Component {

  state = {
    title: ''
  };



  componentWillReceiveProps = newProps => {
    this.setState({
      title: newProps.value
    })
  };

  handleChange = e => {
    this.props.handleChangeTitle(e.target.value);
  };


  closeIcon = () => {
    this.props.closeIcon();
  };

  render() {
    return (
      <div className="search-wrap row" style={this.props.style}>
        <div className="col-4 hide-xs hide-s">
        </div>
        <div className="search-holder-wrap col-12 col-md-8">

          <form className="search-holder" onSubmit={e => {
            e.preventDefault();
            this.props.searchFieldEventEmitter.activate()
          }}>
            <div className="input-holder animate">
              <input type="text"
                     placeholder="Search"
                     className="animate-input search-placeholder"
                     value={this.state.title}
                     onChange={this.handleChange}/>

              <span className="ic-search-ico icon-left icon"/>
              <span className={classNames('ic-close-ico icon-right icon', {nonDispayed: !this.state.title})}
                    onClick={this.closeIcon}/>
              <span className="bar"/>
            </div>

          </form>
        </div>
      </div>
     )
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/SearchField.jsx